<template>
	<slider-form-group label="Volume" :min="0" :max="100" :step="1" :value="value" :reset-value="100" @input="$emit('input', $event)" @change="$emit('change', $event)">
		<span class="text-muted">{{ value }}%</span>
	</slider-form-group>
</template>

<script>
import SliderFormGroup from './SliderFormGroup.vue';

export default {
	components: { SliderFormGroup },
	props: {
		value: { type: Number, required: true },
	},
};
</script>
